var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 43,
    r: 43,
    fill: "#0DA018"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.6184 31.2484L59.6179 31.248C59.1384 30.769 58.4882 30.5 57.8106 30.5C57.1328 30.5 56.4828 30.769 56.0033 31.248L56.0031 31.2482L37.9218 49.3295L30.8136 42.2213L30.8074 42.2151L30.8009 42.209C30.3161 41.7573 29.6749 41.5113 29.0124 41.523C28.3498 41.5347 27.7176 41.8031 27.2491 42.2717C26.7805 42.7403 26.5121 43.3724 26.5004 44.035L26.5004 44.035C26.4887 44.6976 26.7347 45.3388 27.1864 45.8236L27.1924 45.83L27.1987 45.8363L36.1143 54.752L36.1146 54.7522C36.5941 55.231 37.2441 55.5 37.9218 55.5C38.5996 55.5 39.2495 55.231 39.729 54.7522L39.7293 54.752L59.6181 34.8631L59.6184 34.8629C60.0971 34.3834 60.3662 33.7334 60.3662 33.0557C60.3662 32.3779 60.0971 31.7279 59.6184 31.2484Z",
    fill: "white",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.110812f5e96a506d5d8c1b457da1fe0a.svg";
export { ForwardRef as ReactComponent };